<template>
    <v-switch
      v-model="dialog"
      color="blue"
      label="Busca geral"
    ></v-switch>
</template>

<script>
  export default {
    name: 'search-all-folders',
    data() {
      return {
      };
    },
    computed: {
      dialog: {
        get() {
          return this.$store.getters.globalSearch;
        },
        set(value) {
          this.$store.dispatch('setGlobalSearch', value);
        },
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/base/SearchAllFolders.vue